const adNormSetsTabConfig = {
  tabsList: [
    {
      key: 'ad',
      label: 'Offer Sets'
    },
    {
      key: 'norm',
      label: 'norms'
    }
  ]
}
export default adNormSetsTabConfig
